import {StyledServiceOrderDrawerOrderInfoOrderDetails} from "./styles";

export type ServiceOrderDrawerOrderInfoOrderDetailsProps = {
  customerName: string;
  customerEmail: string;
  price: string;
  deliveryInfo: string;
};

export function ServiceOrderDrawerOrderInfoOrderDetails({
  customerName,
  customerEmail,
  price,
  deliveryInfo,
}: ServiceOrderDrawerOrderInfoOrderDetailsProps) {
  return (
    <StyledServiceOrderDrawerOrderInfoOrderDetails>
      <div className="order-details-item-row">
        <p className="order-details-item">
          Customer: <span className="order-details-item-value">{customerName}</span>
        </p>
        <p className="order-details-item">
          Customer's email:{" "}
          <span className="order-details-item-value">{customerEmail}</span>
        </p>
      </div>

      <div className="order-details-item-row">
        <p className="order-details-item">
          Price: <span className="order-details-item-value">{price}</span>
        </p>
        <p className="order-details-item">
          Est. delivery date:{" "}
          <span className="order-details-item-value">{deliveryInfo}</span>
        </p>
      </div>
    </StyledServiceOrderDrawerOrderInfoOrderDetails>
  );
}
